<template>
    <div id="xinghao">
        <div class="brand container">
            <h4>品牌</h4>
            <ul class="clearfix">
                <li v-for="(item,index) in brandLists" :key="index" class="brandListPart listPart" @click="selectBrand(item,index)">
                    {{item.brandName}}
                    <span v-bind:class="{active:activeIndex===index}"><i class="el-icon-check"></i></span>
                    <span class="exitBtn" @click.stop="exitBrand(item)" v-if="basicsAuth.exitBrand">编辑</span>
                    <i class="el-icon-error activeDelBtn" @click.stop="deleBrand(item)" v-if="basicsAuth.deleBrand"></i>
                </li>
                <li class="addContent" @click="newBrand()" v-if="basicsAuth.newBrand"><i class="el-icon-plus"></i></li>
            </ul>
            <el-dialog :title="textMenu[dialogMenuStatus]" :visible.sync="dislogBrand" :close-on-click-modal="false" width="600px"  @close="emptyDialog('brandForm')">
                <el-form ref="brandForm" :model="brandForm" label-width="100px" :label-position="labelPosition" :rules="brandFormRules">
                    <el-form-item label="品牌名称：" prop="brandName">
                        <el-input clearable v-model.trim="brandForm.brandName" maxlength="12" placeholder="不超过12个字"></el-input>
                    </el-form-item>
                    <el-form-item label="排序：" prop="sort">
                        <el-input clearable v-model.trim="brandForm.sort"></el-input>
                    </el-form-item>
                    <el-form-item label="启用状态：" prop="initiateMode">
                        <el-switch v-model="brandForm.initiateMode" :active-value="1"
                           :inactive-value="-1" ></el-switch>
                    </el-form-item>
                    <el-form-item label="上线状态：" prop="onlineStatus">
                        <el-switch v-model="brandForm.onlineStatus" :active-value="1"
                           :inactive-value="-1" ></el-switch>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer" >
                    <el-button v-if="dialogMenuStatus!=='update'" type="success" @click="addEventFormSubmitBtn('brandForm')">添加 </el-button>
                    <el-button v-else type="success" @click="saveEventFormSubmitBtn('brandForm')">保存</el-button>
                    <el-button @click="emptyDialog('brandForm')">取 消</el-button>
                </span>
            </el-dialog>
        </div>
        <div class="category container">
            <h4>品类</h4>
            <ul class="clearfix">
                <li v-for="(item,index) in categoryLists" :key="index" class="categoryListPart listPart" @click="selectCategory(item,index)">
                    {{item.categoryName}}
                    <span v-bind:class="{active:activeCategoryIndex===index}"><i class="el-icon-check"></i></span>
                    <span class="exitBtn" @click.stop="exitCategory(item)" v-if="basicsAuth.exitCategory">编辑</span>
                    <i class="el-icon-error activeDelBtn" @click.stop="deleCategory(item)" v-if="basicsAuth.deleCategory"></i>
                </li>
                <li class="addContent" @click="newCategory()" v-if="basicsAuth.newCategory"><i class="el-icon-plus"></i></li>
            </ul>
            <el-dialog :title="textCategoryMenu[dialogCategoryStatus]" :visible.sync="dislogCategory" :close-on-click-modal="false" width="600px"  @close="emptyCategoryDialog('categoryForm')">
                <el-form ref="categoryForm" :model="categoryForm" label-width="100px" :label-position="labelPosition" :rules="categoryFormRules">
                    <el-form-item label="品类名称：" prop="categoryName">
                        <el-input clearable v-model.trim="categoryForm.categoryName" maxlength="12" placeholder="不超过12个字"></el-input>
                    </el-form-item>
                    <el-form-item label="排序：" prop="sort">
                        <el-input clearable v-model.trim="categoryForm.sort"></el-input>
                    </el-form-item>
                    <el-form-item label="启用状态：" prop="initiateMode">
                        <el-switch v-model.trim="categoryForm.initiateMode" :active-value="1"
                           :inactive-value="-1"></el-switch>
                    </el-form-item>
                    <el-form-item label="上线状态：" prop="onlineStatus">
                        <el-switch v-model="categoryForm.onlineStatus" :active-value="1"
                           :inactive-value="-1"></el-switch>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer" >
                    <el-button v-if="dialogCategoryStatus!=='update'" type="success" @click="addCategoryFormSubmitBtn('categoryForm')">添加</el-button>
                    <el-button v-else type="success" @click="saveCategoryFormSubmitBtn('categoryForm')">保存</el-button>
                    <el-button @click="emptyCategoryDialog('categoryForm')">取 消</el-button>
                </span>
            </el-dialog>
        </div>
        <div class="Model container">
            <h4>型号</h4>
            <ul class="clearfix">
                <li v-for="(item,index) in modelLists" :key="index" class="modelListPart listPart" @click="selectModel(item,index)">
                    {{item.modelName}}
                    <span v-bind:class="{active:activeModelIndex===index}"><i class="el-icon-check"></i></span>
                    <span class="exitBtn" @click.stop="exitModel(item)" v-if="basicsAuth.exitModel">编辑</span>
                    <i class="el-icon-error activeDelBtn" @click.stop="deleModel(item)" v-if="basicsAuth.deleModel"></i>
                </li>
                <li class="addContent" @click="newModel()" v-if="basicsAuth.newModel"><i class="el-icon-plus"></i></li>
            </ul>
            <el-dialog :title="textModelMenu[dialogModelStatus]" :visible.sync="dislogModel" :close-on-click-modal="false" width="600px"  @close="emptyModelDialog('modelForm')">
                <el-form ref="modelForm" :model="modelForm" label-width="100px" :label-position="labelPosition" :rules="modelFormRules">
                    <el-form-item label="型号名称：" prop="modelName">
                        <el-input clearable v-model.trim="modelForm.modelName" maxlength="25" placeholder="请输入型号名称（不超过20个字）"></el-input>
                    </el-form-item>
                    <el-form-item label="排序：" prop="sort">
                        <el-input clearable v-model.trim="modelForm.sort"></el-input>
                    </el-form-item>
                    <el-form-item label="选择颜色：">
                        <el-select v-model="colorChecklist" filterable multiple placeholder="请选择颜色" style="width: 100%;">
                            <el-option
                                v-for="item in ColorLists"
                                :key="item.colorId"
                                :label="item.colorName"
                                :value="item.colorId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="展示图片：">
                        <el-upload
                            class="avatar-uploader"
                            :data="postData"
                            action="https://up.qiniup.com"
                            :show-file-list="false"
                            :accept="acceptImage"
                            :on-success="handleModelAvatarSuccess"
                            :before-upload="beforeAvatarUpload">
                            <img v-if="imageUrl" :src="imageUrl" class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过5Mb</div>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="启用状态：" prop="initiateMode">
                        <el-switch v-model="modelForm.initiateMode" :active-value="1" :inactive-value="-1"></el-switch>
                    </el-form-item>
                    <el-form-item label="上线状态：" prop="onlineStatus">
                        <el-switch v-model="modelForm.onlineStatus" :active-value="1"
                               :inactive-value="-1"></el-switch>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer" >
                    <el-button v-if="dialogModelStatus!=='update'" type="success" @click="addModelFormSubmitBtn('modelForm')">添加</el-button>
                    <el-button v-else type="success" @click="saveModelFormSubmitBtn('modelForm')">保存</el-button>
                    <el-button @click="emptyModelDialog('modelForm')">取 消</el-button>
                </span>
            </el-dialog>
        </div>
        <div class="Fault container">
            <h4>故障大类</h4>
            <ul class="clearfix">
                <li v-for="(item,index) in faultLists" :key="index" @click="selectFault(item,index)" class="faultListPart listPart">
                    {{item.faultTypesName}}
                    <span v-bind:class="{active:activeFaultIndex===index}"><i class="el-icon-check"></i></span>
                    <!-- <span class="exitBtn" @click.stop="exitFault(item)">编辑</span> -->
                    <i class="el-icon-error activeDelBtn" @click.stop="deleFault(item)"></i>
                </li>
                <li class="addContent" @click="newFault()"><i class="el-icon-plus"></i></li>
            </ul>
            <el-dialog :title="textFaultMenu[dialogFaultStatus]" :visible.sync="dislogFault" :close-on-click-modal="false" width="600px"  @close="emptyFaultDialog('faultForm')">
                <el-form ref="faultForm" :model="faultForm" label-width="100px" :label-position="labelPosition" :rules="faultFormRules">
                    <el-form-item label="故障大类：" prop="faultTypesName">
                        <el-autocomplete
                            v-if="dialogFaultStatus!=='update'"
                            @input="getPicking"
                            style="width: 100%"
                            v-model="faultForm.faultTypesName"
                            :fetch-suggestions="querySearchAsync"
                            placeholder="不超过12个字"
                            @select="handleSelect">
                        </el-autocomplete>
                        <el-input clearable v-else v-model.trim="faultForm.faultTypesName"></el-input>
                    </el-form-item>
                    <el-form-item label="排序：" prop="sort" v-if="isAdd">
                        <el-input clearable v-model="faultForm.sort"></el-input>
                    </el-form-item>
                    <el-form-item label="故障描述" v-if="isAdd">
                        <el-input clearable type="textarea" v-model.trim="faultForm.memo"></el-input>
                    </el-form-item>
                    <el-form-item  label="展示图片：" class="clearfix" v-if="isAdd">
                        <el-upload
                            class="avatar-uploader fl"
                            :data="postData"
                            action="https://up.qiniup.com"
                            :show-file-list="false"
                            :accept="acceptImage"
                            :on-success="handleFaultAvatarSuccess"
                            :before-upload="beforeAvatarUpload">
                            <img v-if="imageFaultUrl" :src="imageFaultUrl" class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过5Mb</div>
                        </el-upload>
                        <el-upload
                            class="avatar-uploader fl"
                            :data="postData"
                            :accept="acceptImage"
                            action="https://upload.qiniup.com"
                            :show-file-list="false"
                            :on-success="handlePictureCardPreview2"
                            :before-upload="beforeAvatarUpload">
                            <img v-if="dialogImageSrc" :src="dialogImageSrc" class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer" >
                    <el-button v-if="dialogFaultStatus!=='update'" type="success" @click="addFaultFormSubmitBtn('faultForm')">添加</el-button>
                    <!-- <el-button v-else type="success" @click="saveFaultFormSubmitBtn('faultForm')">保存</el-button> -->
                    <el-button @click="emptyFaultDialog('faultForm')">取 消</el-button>
                </span>
            </el-dialog>
        </div>
        <div class="faultSub container">
            <h4>故障小类</h4>
            <ul class="clearfix">
                <li v-for="(item,index) in faultSubLists" :key="index" class="faultListPart listPart">
                    {{item.faultSubclassName}}
                    <i class="el-icon-error activeDelBtn" @click.stop="deleFaultSub(item)"></i>
                </li>
                <li class="addContent" @click="newFaultSubClass()"><i class="el-icon-plus"></i></li>
            </ul>
            <el-dialog :title="textFaultSubMenu[dialogFaultSubStatus]" :visible.sync="dislogFaultSub" :close-on-click-modal="false" width="600px"  @close="emptyFaultSubDialog('faultSubForm')">
                <el-form ref="faultSubForm" :model="faultSubForm" label-width="100px" :label-position="labelPosition" :rules="faultSubFormRules">
                    <el-form-item v-if="isAddSub" label="小类简称：" prop="faultSubclassShortName">
                        <el-input clearable v-model.trim="faultSubForm.faultSubclassShortName"></el-input>
                    </el-form-item>
                    <el-form-item label="故障小类：" prop="faultSubclassName">
                        <el-autocomplete
                            v-if="dialogFaultSubStatus!=='update'"
                            @input="getSubPicking"
                            style="width: 100%"
                            v-model="faultSubForm.faultSubclassName"
                            :fetch-suggestions="querySubSearchAsync"
                            placeholder="请输入故障小类名称（不超过32个字）"
                            @select="handleSubSelect">
                        </el-autocomplete>
                        <el-input clearable v-else v-model.trim="faultSubForm.faultSubclassName"></el-input>
                    </el-form-item>
                    <el-form-item label="排序：" prop="sort" v-if="isAddSub">
                        <el-input clearable v-model.trim="faultSubForm.sort"></el-input>
                    </el-form-item>
                    <el-form-item label="故障描述" v-if="isAddSub">
                        <el-input clearable type="textarea" v-model.trim="faultSubForm.memo"></el-input>
                    </el-form-item>
                    <el-form-item  label="展示图片：" v-if="isAddSub">
                        <el-upload
                            class="avatar-uploader"
                            :data="postData"
                            action="https://up.qiniup.com"
                            :show-file-list="false"
                            :accept="acceptImage"
                            :on-success="handleFaultSubAvatarSuccess"
                            :before-upload="beforeAvatarUpload">
                            <img v-if="imageFaultSubUrl" :src="imageFaultSubUrl" class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过5Mb</div>
                        </el-upload>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer" >
                    <el-button v-if="dialogFaultSubStatus!=='update'" type="success" @click="addFaultSubFormSubmitBtn('faultSubForm')">添加</el-button>
                    <el-button @click="emptyFaultSubDialog('faultSubForm')">取 消</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import store from '../../store/store'
    import {genUpToken} from "./com/qiniuToken.js";
    import {getPermission} from '../../api/authRequest'
    import {
        selectAllBrand,
        insertBrand,
        deleteBrand,
        updateBrand,
        selectCategory,
        updateCategory,
        insertCategory,
        selectAll,
        deleteCategory,
        insertModel,
        selectModel,
        deleteModel,
        updateModel,
        uploadImgs,
        selectMainfaultTypes,
        addModelType,
        selectfaultTypes, //故障大类接口
        updateFaultTypes,
        updatemodelMainType,
        selectMainFaultSubclass,
        addFaultSubclass,
        updateByPrimaryKeySelectives,
        selectFaultSubclass
    } from "../../api/api";
    export default {
        name: 'xinghao',
        data() {
            const validateNumber = (rule, value, callback) => {
                if (/^99$|^(\d|[1-9]\d)$/.test(value) == false) {
                    callback(new Error("请输入一个大于0,小于99的整数"));
                }else {
                    callback();
                }
            }
            return {
                dialogVisible: false,
                postData:{token:''},
                fileList: [],
                qiniuaddr: 'pic.allscs.cn',// 这是七牛云空间的外链默认域名
                ruleImg:'imageView2/0/q/75|imageslim',//规则
                imageUrl: '',       //型号图片
                imageFaultUrl:'',   //故障大类图片
                dialogImageSrc:'',  //故障分类图标
                imageFaultSubUrl:'',//故障小类图片
                acceptImage: "image/jpeg,image/jpg,image/png",
                selectedLists: [],
                students: [],
                defaultBrandId: '',        //默认品牌Id
                defaultCategoryId: '',     //默认品类Id
                defaultModelId:'',         //默认型号Id
                defaultFaultTypesId:'',    //默认故障大类Id
                defaultFaultSubTypesId:'', //默认故障小类Id
                activeIndex:0,
                activeCategoryIndex:0,
                activeModelIndex:0,
                activeFaultIndex:0,
                labelPosition:'left',
                dislogBrand:false,
                dialogMenuStatus: "",
                textMenu: {
                    update: "修改品牌",
                    create: "新增品牌"
                },
                brandLists:[],
                brandForm:{
                    brandName: '',
                    sort: '',
                    initiateMode: 1,
                    onlineStatus: 1,
                },
                upForm:{upImgs:''},
                brandFormRules:{//validateRoleName
                    brandName: [{ required: true, message: "请输入品牌名称", trigger: "blur" }],
                    sort: [{ required: true, validator: validateNumber, trigger: 'blur' }],
                },
                dislogCategory:false,
                dialogCategoryStatus: "",
                textCategoryMenu: {
                    update: "修改品类",
                    create: "新增品类"
                },
                categoryForm:{
                    categoryName: '',
                    sort: '',
                    initiateMode: 1,
                    onlineStatus:1,
                },
                categoryFormRules:{//validateRoleName
                    categoryName: [{ required: true, message: "请输入品类名称", trigger: "blur" }],
                    sort: [{ required: true, validator: validateNumber, trigger: 'blur' }],
                },
                categoryLists:[],
                dislogModel:false,
                dialogModelStatus: "",
                textModelMenu: {
                    update: "修改型号",
                    create: "新增型号"
                },
                colorChecklist:[],
                modelForm:{
                    modelName: '',
                    sort: '',
                    colorId: '',
                    images:'',
                    initiateMode: 1,
                    onlineStatus:1,
                },
                modelFormRules:{//validateRoleName
                    modelName: [{ required: true, message: "请输入型号名称", trigger: "blur" }],
                    sort: [{ required: true, validator: validateNumber, trigger: 'blur' }],
                },
                modelLists:[],
                dislogFault:false,
                dialogFaultStatus: "",
                textFaultMenu: {
                    update: "修改故障大类",
                    create: "新增故障大类"
                },
                faultForm:{
                    sort: '',
                    images:'',
                    bannerImages:'',
                    faultTypesName:'',
                    faultTypesId:'',
                    memo:''
                },
                faultFormRules:{//validateRoleName
                    faultTypesName:[{ required: true, message: "请输入故障大类名称", trigger: "blur" }],
                    memo:[{ required: true, message: "请输入故障描述", trigger: "blur" }],
                    sort: [{ required: true, validator: validateNumber, trigger: 'blur' }],
                },
                faultLists:[],
                faultArray:[],
                isAdd:true,
                dislogFaultSub:false,
                dialogFaultSubStatus: "",
                textFaultSubMenu: {
                    update: "修改故障小类",
                    create: "新增故障小类"
                },
                faultSubForm:{
                    faultSubclassShortName:'',
                    faultSubclassId:'',
                    faultSubclassName:'',
                    sort: '',
                    images:'',
                    memo:''
                },
                faultSubFormRules:{//validateRoleName
                    faultSubclassShortName:[{ required: true, message: "请输入故障小类简称", trigger: "blur" }],
                    faultSubclassName:[{ required: true, message: "请输入故障小类名称", trigger: "blur" }],
                    memo:[{ required: true, message: "请输入故障描述", trigger: "blur" }],
                    sort: [{ required: true, validator: validateNumber, trigger: 'blur' }],
                },
                faultSubLists:[],
                faultSubArray:[],
                isAddSub:true,
                ColorLists:[],
                checkedColorIdList:[],
                basicsAuth:{
                    newBrand:false,
                    exitBrand:false,
                    deleBrand:false,
                    newCategory:false,
                    exitCategory:false,
                    deleCategory:false,
                    newModel:false,
                    exitModel:false,
                    deleModel:false,
                    newFault:false,
                    exitFault:false,
                }
            }
        },
        mounted () {
            this.getColorList();
            this.getBrandLists();
            this.getFaultNameList();
            this.basicsAuth.newBrand= getPermission('/api/basicSetting/brand/insertBrand');
            this.basicsAuth.exitBrand= getPermission('/api/basicSetting/brand/updateBrand');
            this.basicsAuth.deleBrand= getPermission('/api/basicSetting/brand/deleteBrand');
            this.basicsAuth.newCategory= getPermission('/api/basicSetting/category/insertCategory');
            this.basicsAuth.exitCategory= getPermission('/api/basicSetting/category/updateCategory');
            this.basicsAuth.deleCategory= getPermission('/api/basicSetting/category/deleteCategory');
            this.basicsAuth.newModel= getPermission('/api/basicSetting/model/insertModel');
            this.basicsAuth.exitModel= getPermission('/api/basicSetting/model/updateModel');
            this.basicsAuth.deleModel= getPermission('/api/basicSetting/model/deleteModel');
        },
        methods: {
            handleModelAvatarSuccess(res, file) {
                this.imageUrl = 'http://' + this.qiniuaddr + '/' + res.key+'?imageslim'
                this.modelForm.images = this.imageUrl
            },
            beforeAvatarUpload(file) {
                const isPNG = file.type === 'image/png';
                const isJPG = file.type === 'image/jpeg';
                const isLt2M = file.size / 1024 / 1024 < 10;
                if (!isJPG&&!isPNG) {
                    this.$message.error('上传头像图片只能是 JPG 格式 和Png 格式!');
                }
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 10MB!');
                }
                return isLt2M;
            },
            handleFaultAvatarSuccess(res, file) {
                this.imageFaultUrl = 'http://' + this.qiniuaddr + '/' + res.key+'?imageslim'
                this.faultForm.images = this.imageFaultUrl
            },
            handlePictureCardPreview2(res, file) {
                this.dialogImageSrc = 'http://' + this.qiniuaddr + '/' + res.key +'?imageslim'
                this.faultForm.bannerImages = this.dialogImageSrc;
            },
            handleFaultSubAvatarSuccess(res, file) {
                this.imageFaultSubUrl = 'http://' + this.qiniuaddr + '/' + res.key+'?imageslim'
                this.faultSubForm.images = this.imageFaultSubUrl;
            },
            //查询颜色or获取颜色
            getColorList: function () {
                selectAll().then(res => {
                if (res.data.status == 100) {
                    this.ColorLists = res.data.results
                    // console.log(this.ColorLists)
                } else {
                    this.$message({
                    message: res.data.message,
                    type: "error"
                    });
                }
                }).catch((error) => {
                this.$Message.error(error.message);
                })
            },
            //查询品牌or获取品牌
            getBrandLists() {
                selectAllBrand().then(res => {
                    if (res.data.status==100) {
                        this.brandLists = res.data.results
                        if(res.data.results.length > 0){
                            this.defaultBrandId = res.data.results[0].brandId
                            this.getCategoryList()
                        }else{
                            this.categoryLists = [];
                            this.modelLists = [];
                            this.faultLists = [];
                            this.faultSubLists = [];
                        }

                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //获取品类
            getCategoryList(){
                const brandId = this.defaultBrandId
                const brandData = {brandId:brandId}
                selectCategory(brandData).then((res) => {
                    if (res.data.status == 100) {
                        this.categoryLists = res.data.results;
                        if (res.data.results.length > 0) {
                            this.defaultCategoryId = res.data.results[0].categoryId;
                            this.getModelList();
                        }else{
                            this.modelLists = [];
                            this.faultLists = [];
                            this.faultSubLists = [];
                        }
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) => {
                    this.$Message.error(error.message);
                })
            },
            //获取型号
            getModelList(){
                let para = {
                    brandId:this.defaultBrandId,
                    categoryId:this.defaultCategoryId
                }
                selectModel(para).then(res => {
                    if (res.data.status==100) {
                        this.modelLists = res.data.results
                        if(res.data.results.length > 0){
                            this.defaultModelId = res.data.results[0].modelId;
                            this.getFaultList();
                        }else{
                            this.modelLists = [];
                            this.faultLists = [];
                        }

                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //获取故障大类
            getFaultList(){
                let para = {
                    modelId:this.defaultModelId
                }
                selectMainfaultTypes(para).then(res => {
                    if (res.data.status==100) {
                        this.faultLists = res.data.results;
                        if(res.data.results.length > 0){
                            this.defaultFaultTypesId = this.faultLists[0].faultTypesId;
                            console.log(this.defaultFaultTypesId)
                            this.getFaultSubList();
                        }else{
                            this.faultSubLists = [];
                        }

                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //获取故障小类
            getFaultSubList(){
                let para = {
                    modelId:this.defaultModelId,
                    faulttypesId:this.defaultFaultTypesId
                }
                console.log(para)
                selectMainFaultSubclass(para).then(res => {
                    if (res.data.status==100) {
                        this.faultSubLists = res.data.results;
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //清空dialog
            emptyDialog(formName) {
                this.$refs[formName].resetFields();
                this.dislogBrand = false
            },
            //清空dialog2
            emptyCategoryDialog(formName) {
                this.$refs[formName].resetFields();
                this.dislogCategory = false
            },
            //清空dialog3
            emptyModelDialog() {
                this.modelForm={}
                this.colorChecklist = []
                // this.students=[]
                this.imageUrl=''
                this.dislogModel = false
            },
            //清空dialog4
            emptyFaultDialog() {
                this.faultForm={}
                this.imageFaultUrl=''
                this.dialogImageSrc = "";
                this.dislogFault = false
            },
            //清空dialog5
            emptyFaultSubDialog() {
                this.faultSubForm={}
                this.imageFaultSubUrl=''
                this.dislogFaultSub = false
                this.isAddSub = true;
            },
            //选中品牌
            selectBrand(item,index) {
                this.activeIndex = index;
                this.activeCategoryIndex = 0;
                this.activeModelIndex = 0;
                this.activeFaultIndex = 0;
                this.brandForm = Object.assign({}, item);
                this.defaultBrandId = this.brandForm.brandId
                this.getCategoryList()
            },
            //新增品牌
            newBrand() {
                this.brandForm = {
                    brandName: '',
                    sort: '',
                    initiateMode: 1,
                    onlineStatus: 1,
                },
                this.dislogBrand = true
                this.dialogMenuStatus = "create";
            },
            //确定新增品牌
            addEventFormSubmitBtn(formname){
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        let para={
                            brandName:this.brandForm.brandName,
                            sort:this.brandForm.sort,
                            initiateMode:this.brandForm.initiateMode,
                            onlineStatus:this.brandForm.onlineStatus
                        }
                        insertBrand(para).then(res => {
                            if (res.data.status==100) {
                                this.$message({
                                    message: res.data.message,
                                    type: "success"
                                });
                                /*关闭弹窗，重置输入框*/
                                this.dislogBrand = false;
                                this.$refs[formname].resetFields();
                                /*刷新品牌列表*/
                                this.getBrandLists();
                            }else{
                                this.$message({
                                    message: res.data.message,
                                    type: "error"
                                });
                            }
                        }).catch((error) =>{
                            this.$Message.error(error.message);
                        })
                    } else {
                        console.log('验证未通过');
                        return false;
                    }
                });
            },
            //编辑品牌
            exitBrand(item) {
                this.dislogBrand = true
                this.dialogMenuStatus = "update";
                this.brandForm = Object.assign({}, item);
                // console.log(this.brandForm)
            },
            //确定保存品牌
            saveEventFormSubmitBtn(formname){
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        // console.log('验证成功')
                        /*获取当前input上输入的文字*/
                        // console.log(this.triggerCurrenNodeData.deptId)
                        let para={
                            brandId:this.brandForm.brandId,
                            brandName:this.brandForm.brandName,
                            sort:this.brandForm.sort,
                            initiateMode:this.brandForm.initiateMode,
                            onlineStatus:this.brandForm.onlineStatus
                        }
                        updateBrand(para).then(res => {
                            if (res.data.status==100) {
                                this.$message({
                                    message: res.data.message,
                                    type: "success"
                                });
                                /*关闭弹窗，重置输入框*/
                                this.dislogBrand = false;
                                this.$refs[formname].resetFields();
                                /*刷新品牌列表*/
                                this.getBrandLists();
                            }
                        }).catch((error) =>{
                            this.$Message.error(error.message);
                        })
                    } else {
                        console.log('验证未通过');
                        return false;
                    }
                });
            },
            //删除品牌
            deleBrand(item) {
                this.brandForm = Object.assign({}, item);
                this.$confirm("确认删除该品牌?", "提示", {
                    type: "warning"
                }).then(() => {
                    const brandId = this.brandForm.brandId
                    const brandData = {brandId:brandId}
                    deleteBrand(brandData).then((res) => {
                        if (res.data.status == 100) {
                            this.$message({
                                message: res.data.message,
                                type: "success"
                            });
                            /*刷新列表*/
                            this.getBrandLists();
                            this.activeIndex=0;
                        }else{
                            this.$message({
                                message: res.data.message,
                                type: "error"
                            });
                        }
                    }).catch((error) => {
                        this.$Message.error(error.message);
                    })
                }).catch(() => {});
            },
            //选中品类
            selectCategory(item,index) {
                this.activeCategoryIndex = index;
                this.activeModelIndex = 0;
                this.activeFaultIndex = 0;
                this.categoryForm = Object.assign({}, item);
                this.defaultCategoryId = this.categoryForm.categoryId
                this.getModelList()
            },
            //新增品类
            newCategory() {
                this.categoryForm = {
                    categoryName: '',
                    sort: '',
                    initiateMode: 1,
                    onlineStatus:1,
                }
                this.dislogCategory = true
                this.dialogCategoryStatus = "create";
            },
            //确定新增品类
            addCategoryFormSubmitBtn(formname){
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        // console.log('验证成功')
                        let para={
                            brandId:this.defaultBrandId,
                            categoryName:this.categoryForm.categoryName,
                            sort:this.categoryForm.sort,
                            initiateMode:this.categoryForm.initiateMode,
                            onlineStatus:this.categoryForm.onlineStatus
                        }
                        insertCategory(para).then(res => {
                            if (res.data.status==100) {
                                this.$message({
                                    message: res.data.message,
                                    type: "success"
                                });
                                /*关闭弹窗，重置输入框*/
                                this.dislogCategory = false;
                                this.$refs[formname].resetFields();
                                /*刷新品牌列表*/
                                this.getCategoryList()
                            }else{
                                this.$message({
                                    message: res.data.message,
                                    type: "error"
                                });
                            }
                        }).catch((error) =>{
                            this.$Message.error(error.message);
                        })
                    } else {
                        console.log('验证未通过');
                        return false;
                    }
                });
            },
            //编辑品类
            exitCategory(item) {
                this.dislogCategory = true
                this.dialogCategoryStatus = "update";
                this.categoryForm = Object.assign({}, item);
            },
            //确定保存品类
            saveCategoryFormSubmitBtn(formname){
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        // console.log('验证成功')
                        let para={
                            categoryId:this.categoryForm.categoryId,
                            brandId:this.defaultBrandId,
                            categoryName:this.categoryForm.categoryName,
                            sort:this.categoryForm.sort,
                            initiateMode:this.categoryForm.initiateMode,
                            onlineStatus:this.categoryForm.onlineStatus
                        }
                        updateCategory(para).then(res => {
                            if (res.data.status==100) {
                                this.$message({
                                    message: res.data.message,
                                    type: "success"
                                });
                                /*关闭弹窗，重置输入框*/
                                this.dislogCategory = false;
                                this.$refs[formname].resetFields();
                                /*刷新列表*/
                                this.getCategoryList();
                            }
                        }).catch((error) =>{
                            this.$Message.error(error.message);
                        })
                    } else {
                        console.log('验证未通过');
                        return false;
                    }
                });
            },
            //删除品类
            deleCategory(item){
                this.categoryForm = Object.assign({}, item);
                this.$confirm("确认删除该品类?", "提示", {
                    type: "warning"
                }).then(() => {
                    const categoryId = this.categoryForm.categoryId
                    const categoryData = {categoryId:categoryId}
                    deleteCategory(categoryData).then((res) => {
                        if (res.data.status == 100) {
                            this.$message({
                                message: res.data.message,
                                type: "success"
                            });
                            /*刷新列表*/
                            this.getCategoryList();
                            this.activeCategoryIndex = 0;

                        }else{
                            this.$message({
                                message: res.data.message,
                                type: "error"
                            });
                        }
                    }).catch((error) => {
                        this.$Message.error(error.message);
                    })
                }).catch(() => {});
            },
            //选中型号
            selectModel(item,index) {
                this.activeModelIndex = index;
                this.activeFaultIndex = 0;
                this.modelForm = Object.assign({}, item);
                this.defaultModelId = this.modelForm.modelId
                this.getFaultList()
            },
            //新增型号
            newModel() {
                this.modelForm ={
                    modelName: '',
                    sort: '',
                    colorId: '',
                    images:'',
                    initiateMode: 1,
                    onlineStatus:1,
                };
                this.dislogModel = true
                this.dialogModelStatus = "create";
            },
            //确定新增型号
            addModelFormSubmitBtn(formname){
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        console.log('验证成功')
                        console.log(this.modelForm)
                        let para={
                            categoryId:this.defaultCategoryId,
                            brandId:this.defaultBrandId,
                            modelName:this.modelForm.modelName,
                            colorId:this.colorChecklist.toString(),
                            images:this.modelForm.images,
                            sort:this.modelForm.sort,
                            initiateMode:this.modelForm.initiateMode,
                            onlineStatus:this.modelForm.onlineStatus
                        }
                        // console.log(para)
                        insertModel(para).then(res => {
                            if (res.data.status==100) {
                                this.$message({
                                    message: res.data.message,
                                    type: "success"
                                });
                                /*关闭弹窗，重置输入框*/
                                this.dislogModel = false;
                                this.$refs[formname].resetFields();
                                /*刷新*/
                                this.getModelList();
                            }else{
                                this.$message({
                                    message: res.data.message,
                                    type: "error"
                                });
                            }
                        }).catch((error) =>{
                            this.$Message.error(error.message);
                        })
                    } else {
                        console.log('验证未通过');
                        return false;
                    }
                });
            },
            //编辑型号
            exitModel(item) {
                this.dislogModel = true
                this.dialogModelStatus = "update";
                this.modelForm = Object.assign({}, item);
                this.imageUrl = this.modelForm.images
                this.modelForm.color.forEach(item =>{
                    this.colorChecklist.push(item.colorId)
                })
            },

            //确定保存型号
            saveModelFormSubmitBtn(formname){
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        let para={
                            modelId:this.modelForm.modelId,
                            categoryId:this.defaultCategoryId,
                            brandId:this.defaultBrandId,
                            modelName:this.modelForm.modelName,
                            colorId:this.colorChecklist.toString(),
                            images:this.modelForm.images,
                            sort:this.modelForm.sort,
                            initiateMode:this.modelForm.initiateMode,
                            onlineStatus:this.modelForm.onlineStatus
                        }
                        updateModel(para).then(res => {
                            if (res.status===200) {
                                // this.theData = res.data.results.Deptlist
                                console.log(res.data.results)
                                this.$message({
                                    message: "恭喜你，修改成功",
                                    type: "success"
                                });
                                /*关闭弹窗，重置输入框*/
                                this.dislogModel = false;
                                this.$refs[formname].resetFields();
                                /*刷新*/
                                this.getModelList();
                            }
                        }).catch((error) =>{
                            this.$Message.error(error.message);
                        })
                    } else {
                        console.log('验证未通过');
                        return false;
                    }
                });
            },
            //删除型号
            deleModel(item){
                this.modelForm = Object.assign({}, item);

                this.$confirm("确认删除该型号?", "提示", {
                    type: "warning"
                }).then(() => {
                    const modelId = this.modelForm.modelId
                    const modelData = {modelId:modelId}
                    deleteModel(modelData).then((res) => {
                    if (res.data.status == 100) {
                        this.$message({
                            message: res.data.message,
                            type: "success"
                        });
                        /*刷新列表*/
                        this.getModelList();
                        this.modelForm = {}
                        // this.activeCategoryIndex = 0;
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) => {
                    this.$Message.error(error.message);
                })
                }).catch(() => {});
            },
            //选中故障大类
            selectFault(item,index) {
                this.activeFaultIndex = index
                this.faultForm = Object.assign({}, item);
                this.defaultFaultTypesId = this.faultForm.faultTypesId;
                this.getFaultSubList();
            },
            //新增故障大类
            newFault() {
                this.faultForm ={
                    faultTypesName: '',
                    sort: '',
                    images:'',
                    faultTypesName:'',
                    faultTypesId:'',
                    memo:'',

                };
                this.dislogFault = true
                this.dialogFaultStatus = "create";
            },
            //确定新增故障大类
            addFaultFormSubmitBtn(formname){
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        let para={
                            modelId:this.defaultModelId,
                            memo:this.faultForm.memo,
                            images:this.faultForm.images,
                            sort:this.faultForm.sort,
                            faultTypesName:this.faultForm.faultTypesName,
                            faultTypesId:this.faultForm.faultTypesId,
                            bannerImages:this.faultForm.bannerImages
                        }
                        // console.log(para)
                        addModelType(para).then(res => {
                            if (res.data.status==100) {
                                this.$message({
                                    message: res.data.message,
                                    type: "success"
                                });
                                /*关闭弹窗，重置输入框*/
                                this.dislogFault = false;
                                this.$refs[formname].resetFields();
                                this.isAdd = true
                                /*刷新*/
                                this.getFaultList();
                            }else{
                                this.$message({
                                    message: res.data.message,
                                    type: "error"
                                });
                            }
                        }).catch((error) =>{
                            this.$Message.error(error.message);
                        })
                    } else {
                        console.log('验证未通过');
                        return false;
                    }
                });
            },
            //删除故障大类
            deleFault(item){
                this.faultForm = Object.assign({}, item);
                this.$confirm("确认删除该故障大类?", "提示", {
                    type: "warning"
                }).then(() => {
                    const faultTypesId = this.faultForm.faultTypesId
                    const id = this.faultForm.id
                    let para = {
                        id:id,
                        faultTypesId:faultTypesId
                    }
                    updatemodelMainType(para).then((res) => {
                    if (res.data.status == 100) {
                        this.$message({
                            message: res.data.message,
                            type: "success"
                        });
                        /*刷新列表*/
                        this.getFaultList();
                        this.faultForm = {}
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) => {
                    this.$Message.error(error.message);
                })
                }).catch(() => {});
            },
            querySearchAsync(queryString, cb) {
                var faultArray = this.faultArray;
                var results = queryString ? faultArray.filter(this.createStateFilter(queryString)) : faultArray;
                cb(results);
            },
            querySubSearchAsync(queryString, cb) {
                var faultSubArray = this.faultSubArray;
                var results = queryString ? faultSubArray.filter(this.createStateFilter(queryString)) : faultSubArray;
                cb(results);
            },
            createStateFilter(queryString) {
                return (state) => {
                    console.log(state)
                    return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            handleSelect(item) {
                this.isAdd = false
                this.faultForm.faultTypesId = item.faultTypesId
                this.faultForm.faultTypesName = item.value
            },
            handleSubSelect(item) {
                this.isAddSub = false
                this.faultSubForm.faultSubclassId = item.faultSubclassId
                this.faultSubForm.faultSubclassName = item.value
            },
            //新增故障小类
            newFaultSubClass() {
                this.getFaultSubNameList();
                this.faultSubForm ={
                    faultSubclassShortName:'',
                    faultSubclassId:'',
                    faultSubclassName:'',
                    sort: '',
                    images:'',
                    memo:''
                };
                this.dislogFaultSub = true
                this.dialogFaultSubStatus = "create";
            },
            //确定新增故障小类
            addFaultSubFormSubmitBtn(formname){
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        let para={
                            modelId:this.defaultModelId,
                            memo:this.faultSubForm.memo,
                            images:this.faultSubForm.images,
                            sort:this.faultSubForm.sort,
                            faultSubclassName:this.faultSubForm.faultSubclassName,
                            faultSubclassShortName:this.faultSubForm.faultSubclassShortName,
                            faulttypesId:this.defaultFaultTypesId,
                            faultSubclassId:this.faultSubForm.faultSubclassId
                        }
                        addFaultSubclass(para).then(res => {
                            if (res.data.status==100) {
                                this.$message({
                                    message: res.data.message,
                                    type: "success"
                                });
                                /*关闭弹窗，重置输入框*/
                                this.dislogFaultSub = false;
                                this.$refs[formname].resetFields();
                                this.isAddSub = true
                                /*刷新*/
                                this.getFaultSubList();
                            }else{
                                this.$message({
                                    message: res.data.message,
                                    type: "error"
                                });
                            }
                        }).catch((error) =>{
                            this.$Message.error(error.message);
                        })
                    } else {
                        console.log('验证未通过');
                        return false;
                    }
                });
            },
            //删除故障小类
            deleFaultSub(item){
                this.faultSubForm = Object.assign({}, item);
                this.$confirm("确认删除该故障小类?", "提示", {
                    type: "warning"
                }).then(() => {
                    const faultSubclassId = this.faultSubForm.faultSubclassId
                    const id = this.faultSubForm.id
                    let para = {
                        id:id,
                        faultSubclassId:faultSubclassId
                    }
                    updateByPrimaryKeySelectives(para).then((res) => {
                    if (res.data.status == 100) {
                        this.$message({
                            message: res.data.message,
                            type: "success"
                        });
                        /*刷新列表*/
                        this.getFaultSubList();
                        this.faultSubForm = {}
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) => {
                    this.$Message.error(error.message);
                })
                }).catch(() => {});
            },
            //监听故障大类名称Input
            getPicking(e){
                this.isAdd = true
            },
            //监听故障小类名称Input
            getSubPicking(e){
                this.isAddSub = true
            },
            //获取故障大类名称列表
            getFaultNameList(){
                selectfaultTypes({}).then(res => {
                    if (res.data.status==100) {
                        let faultNameArray = res.data.results
                        faultNameArray.forEach((item,index)=>{
                            this.faultArray.push({
                                value:item.faultTypesName,
                                faultTypesId:item.faultTypesId
                            })
                        })
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //获取故障小类名称列表
            getFaultSubNameList(){
                let faulttypesId = this.defaultFaultTypesId;
                let para = {faulttypesId:faulttypesId};
                this.faultSubArray = [];
                selectFaultSubclass(para).then(res => {
                    if (res.data.status==100) {
                        let faultSubNameArray = res.data.results;
                        if(faultSubNameArray.length > 0){
                            faultSubNameArray.forEach((item,index)=>{
                                this.faultSubArray.push({
                                    value:item.faultSubclassName,
                                    faultSubclassId:item.faultSubclassId
                                })
                            })
                        }

                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            }
        },
        created:function(){
            var token = "";
            var policy = {};
            var bucketName = 'hohofast';
            var AK ='VYiFElH26Am5EbV9T3nACEfNt6xBRz6gEREDFlis';
            var SK = 'sFELHoXSwB8NpiWpPj2Wk7theJCO7Iil-2rwSj31';
            var deadline = Math.round(new Date().getTime() / 1000) + 3600;
            policy.scope = bucketName;
            policy.deadline = deadline;
            token=genUpToken(AK, SK, policy);
            this.postData.token=token;
        },
        watch: {

        }
    }
</script>

<style lang="scss" type="text/css" scoped>
    #xinghao{
        .clearfix{
            clear:both;
            overflow: hidden;
        }
        .container{
            border-bottom: 1px dashed #c6c6c6;
            padding-bottom: 20px;
            h4{
                margin: 15px 0;
                font-weight: 500;
                font-size: 16px;
            }
            .listPart{
                width: 200px;
                float: left;
                border:1px solid #c6c6c6;
                margin:0 15px 10px 0;
                border-radius: 10px;
                height: 80px;
                line-height: 60px;
                text-align: center;
                position: relative;
                z-index: 0;
                cursor: pointer;
                & > span:first-child{
                    display:none;
                }
                span.active{
                    position: absolute;
                    top: -1px;
                    right:-1px;
                    display: block;
                    width: 30px;
                    height: 30px;
                    border-width: 16px;
                    border-style: solid;
                    border-color: #1abc9c #1abc9c #fff #fff;
                    border-top-right-radius:10px;
                    i{
                        position: absolute;
                        font-size: 14px;
                        color:#fff;
                        top: -9px;
                    }
                }
                span.exitBtn{
                    position: absolute;
                    bottom: 0;
                    width: 100%;
                    line-height: 20px;
                    left: 0;
                    border-top:1px solid #c6c6c6;
                    z-index:1;
                    display: block;
                }
                i.activeDelBtn{
                    display: none;
                    position: absolute;
                    top: 5px;
                    left: 5px;
                    color: #c41335;
                }
            }
            .listPart:hover i.activeDelBtn{
                display: block;
            }
            .addContent{
                border:1px dashed #c6c6c6;
                width: 50px;height: 50px;
                line-height: 50px;
                float: left;
                text-align: center;
                margin-top: 15px;
                cursor: pointer;
                i{
                    font-size: 20px;
                }
            }
        }
        .Fault li.listPart{
            line-height:2;
            height:auto;
            padding:20px 0
        }
        .faultSub li.listPart{
            line-height:2;
            height:90px;
            padding:20px;
            word-break: break-word;
        }

    }
</style>
<style lang="scss">
    #xinghao{
        .avatar-uploader .el-upload {
            border: 1px dashed #d9d9d9;
            border-radius: 6px;
            cursor: pointer;
            position: relative;
            overflow: hidden;
        }
        .avatar-uploader .el-upload:hover {
            border-color: #409EFF;
        }
        .avatar-uploader-icon {
            font-size: 28px;
            color: #8c939d;
            width: 178px;
            height: 178px;
            line-height: 178px !important;
            text-align: center;
        }
        .avatar {
            width: 178px;
            height: 178px;
            display: block;
        }
    }
</style>



// WEBPACK FOOTER //
// basicsConfigure.vue?007f5b7a